import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import { environment } from 'src/environments/environment';
import {Observable, of} from 'rxjs';
import { map } from 'rxjs/operators';
import {AuthService} from '../../../lib/auth.service';

@Injectable({
    providedIn: 'root'
})
export class PlaylistService {
    public userInfo;
    private baseurl = environment.apiurl + 'api/v1/';
    private gameurl = environment.stemgameapiurl + 'api/v2/';

    constructor(private http: HttpClient,private _authService:AuthService) {}

    getLearningflowDetails(playlistId){
      this.userInfo = this._authService.getUserInfo();
      console.log("this.userInfo",this.userInfo)
      console.log("getLearningflowDetails",playlistId);
      let url = this.baseurl + 'learningflows/' + playlistId;
      const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            api_key: this.userInfo.apikey,
            username: this.userInfo.username,
            password: this.userInfo.password,
            option: 'urlPath'
        })
      };
      return this.http.get(url,httpOptions).pipe(map((res:Response)=>{
        console.log("getLearningflowDetails API res~~~",res)
        let result = [];
        result.push(res);
        return result;
      }));
    }

    userActivity(data){
      this.userInfo = this._authService.getUserInfo();
      data["userID"] = this.userInfo.userid;
      // let url = this.gameurl + 'userActivity';
      let url = this.gameurl + 'resource-usage';
      const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            api_key: this.userInfo.apikey,
            username: this.userInfo.username,
            password: this.userInfo.password
        })
      };
      return this.http.post(url,data,httpOptions).pipe(map((res:Response)=>{
        let result = [];
        result.push(res);
        return result;
      }))
    }

    getTopicDetails(topicId){
      this.userInfo = this._authService.getUserInfo();
      let url = this.baseurl + 'topics/' + topicId;
      const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            api_key: this.userInfo.apikey,
            username: this.userInfo.username,
            password: this.userInfo.password,
            option: 'urlPath'
        })
      };
      return this.http.get(url,httpOptions).pipe(map((res:Response)=>{
        console.log("get Topic Details API res~~~",res)
        let result = [];
        result.push(res);
        return result;
      }));
    }
}
